import { render, staticRenderFns } from "./CreateAdmin.vue?vue&type=template&id=b0f4ed04&scoped=true&"
import script from "./CreateAdmin.vue?vue&type=script&lang=js&"
export * from "./CreateAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CreateAdmin.vue?vue&type=style&index=0&id=b0f4ed04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f4ed04",
  null
  
)

export default component.exports